const en = {
  "프로필 수정": "Edit Profile",
  "안녕하세요.": "Hello.",
  "{{name}}님": "{{name}}",
  "검색": "Search",
  "전체": "All",
  "성명, 소속, 이메일로 검색할 수 있습니다.": "Search by name, department, work assignment, or email.",
  "검색어를 입력하세요.": "Enter search term.",
  "성명을 입력하세요.": "Enter name.",
  "소속을 입력하세요.": "Enter department.",
  "담당 업무를 입력하세요.": "Enter work assignment.",
  "이메일을 입력하세요.": "Enter email.",
  "휴대폰번호를 입력하세요.": "Enter mobile number.",
  "성명": "Name",
  "소속": "Department",
  "근무처": "Office",
  "직위/직책": "Position",
  "담당 업무": "Work Assignment",
  "휴대폰번호": "Mobile",
  "내선번호": "Extension",
  "이메일": "Email",
  "클립보드에 복사되었습니다.": "Copied to clipboard.",
  "휴대폰번호 복사": "Copy Mobile",
  "이메일 복사": "Copy Email",
  "검색 결과가 없습니다.": "No results found.",
  "페이지에 접근할 수 있는 권한이 없습니다.": "Access denied to this page.",
  "임직원 검색": "Employee Search",
  "결과를 고르면 오른쪽에 전체 정보가 표시됩니다": "Select a result to view full details on the right",
  "결과를 고르면 아래에 전체 정보가 표시됩니다": "Select a result to view full details below",
  "이름/소속명/담당업무/이메일/휴대폰번호 검색": "Search by name, department, work assignment, email, or mobile",
  "총 {{count}}명": "Total {{count}}",
  "조직도": "Org Chart",
  "{{name}}에서 보기": "View in {{name}}",
  "클릭하면 {{name}}로 이동합니다": "Click to open in {{name}}",
  "직무": "Job",
  "연락처": "Contact",
  "직위": "Position",
  "직책": "Title",
  "복사": "Copy",
  "선택된 임직원이 없습니다": "No employee selected",
  "왼쪽 목록에서 임직원을 선택하세요": "Select an employee from the list on the left",
  "위 목록에서 임직원을 선택하세요": "Select an employee from the list above",
  "계정변경": "Change Account",
  "로그아웃": "Logout",
  "부서 및 임직원": "Departments & Employees",
  "조직도를 불러오는데 실패했습니다.": "Failed to load the organization chart.",
  "관리자": "For Admins",
  "언어 선택": "Select Language",
  "기업 선택": "Select Corporate",
  "릴리즈 노트": "Release Notes",
  "매뉴얼": "Manual",
  "매뉴얼 선택": "Select a manual",
  "권한 관리": "Role Management",
  "권한": "Roles",
  "사용자별 보기": "By User",
  "권한별 보기": "By Role",
  "권한 검색": "Search role",
  "보유자": "Holders",
  "보유한 권한": "Assigned roles",
  "권한 부여": "Grant role",
  "권한 회수": "Revoke role",
  "권한 부여 확인": "Confirm grant",
  "권한 회수 확인": "Confirm revoke",
  "권한이 부여되었습니다.": "Role granted.",
  "권한이 회수되었습니다.": "Role revoked.",
  "변경 실패. 잠시 후 다시 시도해주세요.": "Failed to apply changes. Please try again.",
  "권한 정보를 불러오지 못했습니다.": "Failed to load roles.",
  "사용자 정보를 불러오지 못했습니다.": "Failed to load users.",
  "보유자가 없습니다.": "No holders.",
  "사용자 또는 권한을 선택하세요": "Select a user or role",
  "좌측에서 사용자나 권한을 선택하면 상세를 확인할 수 있습니다.": "Pick a user or role on the left to view details.",
  "시스템 관리자": "System Admin",
  "법인 관리자": "Corporate Admin",
  "메뉴 관리자": "Menu Admin",
  "기타 권한": "Other",
  "추가할 권한": "Roles to add",
  "제거할 권한": "Roles to remove",
  "변경 전": "Before",
  "변경 후": "After",
  "부여된 그룹": "Assigned groups",
  "펼치기": "Expand",
  "접기": "Collapse",
  "그룹 멤버십을 통해 부여됨": "Granted via group membership",
  "부여 경로": "Source",
  "직접": "Direct",
  "그룹 경유": "Via group",
  "포함하는 권한": "Includes",
  "포함되는 권한": "Included by",
  "함께 부여됨": "Granted together",
  "자동 부여 출처": "Auto-grant source",
  "부여 시 자동 포함": "Auto-included when granted",
  "상위 권한 보유자가 자동 보유": "Auto-held by parent role holders",
  "없음": "None",
  "현재 보유 권한": "Currently assigned",
  "권한 추가/회수": "Add / Revoke",
  "체크박스로 부여, 다시 클릭으로 회수": "Click + to grant, click again to revoke",
  "변경 사항 검토": "Review changes",
  "변경 사유": "Reason",
  "변경 사유를 입력하세요": "Enter the reason",
  "사용자를 선택하세요": "Select a user",
  "권한을 선택하세요": "Select a role",
  "추가할 사용자를 검색하세요": "Search users to add",
  "상위 역할": "Via composite",
  "서비스 계정": "Service Account",
  "직접 회수 불가": "Cannot revoke directly",
  "그룹 또는 상위 역할을 통해 부여됨": "Granted via group or composite role",
  "직접 부여만 보기": "Direct grants only",
  "이름 또는 이메일 검색": "Search by name or email",
  "취소": "Cancel",
  "저장": "Save",
  "회수": "Revoke",
  "보유자 추가": "Add holder",
  "법인 필터": "Corporation filter",
  "총 {{count}}건": "Total {{count}} Items",
  "{{count}}명": "{{count}}",
  "{{count}}개": "{{count}}",
  "외 {{count}}개": "+{{count}} more",
  "이름": "Name",
  "법인": "Corporation",
  "고용 상태": "Employment",
  "관리": "Manage",
  "데이터를 불러오고 있습니다.": "Loading data...",
  "사용자 검색": "Search User",
  "활성": "Active",
  "퇴직": "Resigned",
  "승인대기": "Pending approval",
  "다시 시도": "Retry",
  "사용자 목록을 불러오지 못했습니다.": "Failed to load users.",
  "퇴직자가 없습니다.": "No resigned users.",
  "이름·이메일·사번·UUID": "Name · Email · ID · UUID",
  "이름·이메일·사번·UUID로 검색하거나 법인 필터를 선택하세요.": "Search by name/email/ID/UUID or pick a corporation filter.",
  "사번": "Employee ID",
  "휴대폰": "Mobile",
  "사무실": "Office",
  "가입 승인 관리": "Registration Approval",
  "이름 · 이메일 검색": "Search name · email",
  "인증 완료": "Verified",
  "인증 미완료": "Not Verified",
  "조건에 맞는 신청 건이 없습니다.": "No applications match the criteria.",
  "검색 조건을 변경해 주세요.": "Please change search criteria.",
  "{{count}}명 선택됨": "{{count}} Users Selected",
  "선택 해제": "Deselect",
  "일괄 승인": "Bulk Approve",
  "전체 선택": "Select All",
  "이메일 인증 상태": "Email Verification",
  "전화번호": "Phone",
  "신청일시": "Applied At",
  "승인/거절": "Approve/Deny",
  "승인": "Approve",
  "거절": "Deny",
  "그룹을 선택해주세요.": "Please select a group.",
  "가입승인 - 그룹 지정": "Approval - Assign Group",
  "일괄 승인 - 그룹 지정 ({{count}}명)": "Bulk Approve - Assign Group ({{count}})",
  "승인에 실패했습니다. 잠시 후 다시 시도해주세요.": "Failed to approve. Please try again later.",
  "가입거절": "Deny Registration",
  "가입 거절 시, 해당 계정이 삭제됩니다.": "If the registration is denied, this account will be deleted.",
  "계정을 삭제하시겠습니까?": "Delete this account?",
  "더보기": "More",
  "일": "Sun",
  "월": "Mon",
  "화": "Tue",
  "수": "Wed",
  "목": "Thu",
  "금": "Fri",
  "토": "Sat",
  "{{year}}년 {{month}}월": "{{year}}.{{month}}",
  "이전 달": "Previous month",
  "다음 달": "Next month",
  "지우기": "Clear",
  "오늘": "Today",
  "날짜 선택": "Select date",
  "기간 선택": "Select period",
  "{{count}}일_one": "{{count}} day",
  "{{count}}일": "{{count}} days",
  "{{date}} 부터 · 종료일을 고르세요": "From {{date}} · select an end date",
  "시작일을 고르세요": "Select a start date",
  "연도-월-일": "YYYY-MM-DD",
  "달력 열기": "Open calendar",
  "{{year}}년": "{{year}}",
  "이전 해": "Previous year",
  "다음 해": "Next year",
  "이전 연도 목록": "Previous years",
  "다음 연도 목록": "Next years",
  "1월": "Jan",
  "2월": "Feb",
  "3월": "Mar",
  "4월": "Apr",
  "5월": "May",
  "6월": "Jun",
  "7월": "Jul",
  "8월": "Aug",
  "9월": "Sep",
  "10월": "Oct",
  "11월": "Nov",
  "12월": "Dec",
  "소속 협력사": "Company",
  "이름 · 이메일 · 소속 검색": "Search name · email · company"
};
export {
  en as default
};
